export { default as LOGIN } from './LOGIN';
export { default as CREATE } from './CREATE';
export { default as GET_USER } from './GET_USER';
export { default as FORGOT } from './FORGOT';



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/graphql/index.js
 **/